import { render, staticRenderFns } from "./CertificacionComponent.vue?vue&type=template&id=e59f24e2&"
import script from "./CertificacionComponent.vue?vue&type=script&lang=js&"
export * from "./CertificacionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CertificacionComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports